
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { ValidationError } from '@/utils/cycle-tracking/types';
import { CycleImportRow } from '@/utils/cycle-tracking/import';

interface ValidationAlertsProps {
  errors: ValidationError[];
  warnings: ValidationError[];
  parsedData: any[]; // Changed from CycleImportRow[] to any[] to support empty array indication
}

const ValidationAlerts: React.FC<ValidationAlertsProps> = ({ errors, warnings, parsedData }) => {
  if (errors.length === 0 && warnings.length === 0 && parsedData.length === 0) {
    return null;
  }

  return (
    <>
      {errors.length > 0 && (
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Errors Found</AlertTitle>
          <AlertDescription>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              {errors.map((error, index) => (
                <li key={index}>
                  Row {error.rowIndex + 1}: {error.message} ({error.field})
                </li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}
      
      {warnings.length > 0 && (
        <Alert className="mb-4 border-yellow-500 text-yellow-800">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Warnings</AlertTitle>
          <AlertDescription>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              {warnings.map((warning, index) => (
                <li key={index}>
                  Row {warning.rowIndex + 1}: {warning.message} ({warning.field})
                </li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}
      
      {parsedData.length > 0 && errors.length === 0 && (
        <Alert className="mb-4 border-green-500 text-green-800">
          <CheckCircle className="h-4 w-4" />
          <AlertTitle>Validation Successful</AlertTitle>
          <AlertDescription>
            Found valid cycle entries ready to import.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};

export default ValidationAlerts;
